module.exports = __webpack_public_path__ + "img/about_1971.c674181c.png";